import SizeHelpers from './size-helpers';

const allPhotos = sizes => {
  return SizeHelpers.augment.fromCollection(sizes);
};

const allPhotosCollectedByRootImage = sizes => {
  // we want a hash of all the photos by their root image_file and which contain an array of the related photos
  return allPhotos(sizes).reduce((acc, photo) => {
    if (photo.image_id) {
      const rootId = photo.root_image_id;
      const sizeId = photo.size.key;

      if (!acc[rootId]) {
        acc[rootId] = {};
      }

      if (!acc[rootId][sizeId]) {
        acc[rootId][sizeId] = [];
      }

      acc[rootId][sizeId].push(photo);
    }

    return acc;
  }, {});
};

export { allPhotosCollectedByRootImage };
